import axios from 'axios';
import { API_BASE_URL } from './url_config';

export const uploadAboutImages = async (formData, token) => {
  return await axios.post(`${API_BASE_URL}/about/upload-about-images`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getAboutImages = async (data, token) => {
  return await axios.post(`${API_BASE_URL}/about/get`, data, {
    headers: {
      Authorization: `Bearer ${token}`
    },
  });
};


export const updateStatusAboutImage = async (id, active, token) => {
  return await axios.put(`${API_BASE_URL}/about/update-status/${id}`, {active}, {
    headers: {
      Authorization: `Bearer ${token}`
    },
  });
};